// Models
import {AvailableRecordType, RecordStatusEnum} from "../models"


export type RecordActionKind = "assign" | "continue"

/**
 * @param record
 */
export function recordActionKind(record: AvailableRecordType): RecordActionKind {
    if (record.recordType === "HOLTER") {
        return record.status === RecordStatusEnum.NEW ? "assign" : "continue"
    }

    return record.status === RecordStatusEnum.IN_PROGRESS ? "continue" : "assign"
}

/**
 * @param record
 */
export function hasRecordAction(record: AvailableRecordType): boolean {
    return record.recordType === "ECG" || record.recordType === "HOLTER"
}

/**
 * @param record
 * @param inProgressRecord
 */
export function isInProgressRecord(
  record: AvailableRecordType,
  inProgressRecord: AvailableRecordType | null,
): boolean {
    return inProgressRecord !== null && inProgressRecord.teleRecordId === record.teleRecordId
}

/**
 * @param record
 * @param inProgressRecord
 */
export function isRecordActionDisabled(
  record: AvailableRecordType,
  inProgressRecord: AvailableRecordType | null,
): boolean {
    if (record.recordType !== "ECG" || inProgressRecord === null) {
        return false
    }

    return false === isInProgressRecord(record, inProgressRecord)
}

/**
 * @param record
 * @param inProgressRecord
 */
export function canOpenRecord(
  record: AvailableRecordType | null,
  inProgressRecord: AvailableRecordType | null,
): boolean {
    if (record === null) {
        return false
    }

    return hasRecordAction(record) && false === isRecordActionDisabled(record, inProgressRecord)
}
